import { styled, css } from 'styled-components';
import { colors } from '../../../abstracts';
import { createTransition, dontForwardProps } from '../../../util';
const textFieldAffixLeftSide = css(["height:3.5rem;padding-right:0.625rem;justify-content:start;"]);
const textFieldAffixRightSide = css(["height:3.5rem;padding-left:0.625rem;justify-content:end;"]);
const textFieldAffixNotInteractive = css(["color:", ";pointer-events:none;"], colors.neutralDeeper);
const textFieldAffixInteractive = css(["color:", ";cursor:pointer;"], ({
  theme
}) => theme.secondary);
export const TextFieldAffixContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  displayName: "TextFieldAffixContainer",
  componentId: "asurion-ui-react__sc-1rqi948-0"
})(["display:flex;align-items:center;justify-content:center;flex-grow:0;color:", ";", ";", " ", ";", ""], colors.neutralDeeper, ({
  affixClickable
}) => affixClickable ? textFieldAffixInteractive : textFieldAffixNotInteractive, ({
  disabled
}) => disabled && css(["color:", ";pointer-events:none;"], colors.disabledText), ({
  affixSide
}) => affixSide === 'left' ? textFieldAffixLeftSide : textFieldAffixRightSide, createTransition({
  properties: ['color']
}));